import { EUnitOfMeasure } from '../shared/enum';
import { TInputEngine } from '../shared/iProject';
import { EUnitOfMeasureImperialLabel, EUnitOfMeasureLabel, EUnitOfMeasureMetricLabel } from './enum';

export const typeOfPropeller: TInputEngine = 'typeOfPropeller';
export const numberOfPropellers: TInputEngine = 'numberOfPropellers';
export const propellerDiameter: TInputEngine = 'propellerDiameter';
export const distanceBetweenPropellerAxes: TInputEngine = 'distanceBetweenPropellerAxes';
export const maximumPowerOfThePropeller: TInputEngine = 'maximumPowerOfThePropeller';
export const percentageOfUseInPortManeuvers: TInputEngine = 'percentageOfUseInPortManeuvers';
export const propellerDirectionWithRespectToTheQuay: TInputEngine = 'propellerDirectionWithRespectToTheQuay';

export const enginePhysicalData = {
    [typeOfPropeller]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [numberOfPropellers]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [distanceBetweenPropellerAxes]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [propellerDirectionWithRespectToTheQuay]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [propellerDiameter]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [maximumPowerOfThePropeller]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.power,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.power,
        },
    },
    [percentageOfUseInPortManeuvers]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureLabel.percentage,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureLabel.percentage,
        },
    },
};
